import { useEffect, useState } from 'react';
import { driveKey, type DriveNote } from '../confirm/drive';
import type { RowLeg } from '../lib/row';
import { PRIVATE_MIRROR } from '../lib/feedContext';
import { openBook, forForm, urlOf } from './act';
import { type BookAttempt, openingKey, openingText, useBookOpening } from './bookOpening';
import { useDrive } from './driveNote';
import { venueName } from './meta';
import { useScreen } from './store';

/** «Ссылки нет» после жеста, а дверь с тех пор появилась — надпись врёт. */
export function staleNoLink(attempt: BookAttempt | undefined, door: string | null): boolean {
  return attempt?.state === 'no-link' && door !== null;
}

/** Купон назвал лимит или паузу — сказать, что вторую ногу пересчитали. */
export function limitText(note: DriveNote | undefined, name: string): string | null {
  if (note?.suspended === true) return `${name}: ставка приостановлена — подождите или удалите выбор`;
  if (note?.maxStake !== undefined) return `лимит ${name} ${note.maxStake} — вторую ногу пересчитали по нему`;
  return null;
}

export function BookOpenStatus({ id, leg }: { id: string; leg: RowLeg }): React.ReactElement | null {
  const raw = useBookOpening(s => s.by[openingKey(id, leg.source)]);
  const door = urlOf(id, leg);
  const attempt = staleNoLink(raw, door) ? undefined : raw;
  const url = attempt?.url ?? door;
  const note = useDrive(s => url ? s.byIntent[driveKey(leg.source, url)] : undefined);
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    if (!attempt && !note) return;
    setNow(Date.now());
    const timer = window.setInterval(() => setNow(Date.now()), 1000);
    return () => window.clearInterval(timer);
  }, [attempt, note]);
  const meta = useScreen((s) => s.meta);
  const text = limitText(note, venueName(meta, leg.source))
    ?? openingText(attempt ?? (note ? { at: note.at, url, state: 'sent' } : undefined), note, now, { odds: leg.odds, amount: forForm(leg) });
  const ready = text === 'купон готов' || text === 'исход выбран';
  return text ? <span className={`nx-book-status${ready ? ' ready' : ''}`} role="status">{text}{PRIVATE_MIRROR && door && attempt?.state === 'blocked' && <> <button type="button" onClick={() => openBook(id, leg)}>Открыть {venueName(meta, leg.source)} отдельно</button></>}</span> : null;
}
